import React from 'react';
import { Nav } from 'react-bootstrap';
import NavLinkStyles from './CustomNavLink.module.scss';

type Props = {
  title: string;
  link: string;
};

export const CustomNavLink: React.FC<Props> = ({ title, link }) => {
  return (
    <Nav.Link className={NavLinkStyles.nav_link} href={link}>
      {title}
    </Nav.Link>
  );
};
